import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from './cn.js';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        {...rest}
        className={cn(
          'w-full rounded-xl border border-line bg-surface-2 px-4 py-3 text-base text-text placeholder:text-text-muted resize-y min-h-[96px]',
          'focus:outline-none focus:border-gold/40 focus:bg-surface-3 transition',
          className,
        )}
      />
    );
  },
);
